import { render, staticRenderFns } from "./orderreturn-add.vue?vue&type=template&id=1dcfe4a0&"
import script from "./orderreturn-add.vue?vue&type=script&lang=ts&"
export * from "./orderreturn-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports